import { AbstractRepository } from '@/repositories/abstract-repository';
import { TaskGroup } from '@/tasks/models/task-models';

export class TaskGroupsRepository extends AbstractRepository<TaskGroup> {
    readonly endpoint = 'types/tasks/groups';
}
